import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../payee-input/payee-input.directive';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-real-estate-execution',
  templateUrl: './real-estate-execution.component.html',
  styleUrls: ['./real-estate-execution.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class RealEstateExecutionComponent {
  private fb = inject(FormBuilder);
  private dialogRef =
    inject<MatDialogRef<RealEstateExecutionComponent>>(MatDialogRef);
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private workflowService = inject(WorkflowService);

  loading = false;

  readonly realEstateForm = this.fb.group({
    message: this.fb.control('', {
      validators: Validators.required,
      nonNullable: true,
    }),
  });

  get message() {
    return this.realEstateForm.controls.message;
  }

  private readonly getParams = () => {
    const { message } = this.realEstateForm.getRawValue();
    return { message };
  };

  async submit() {
    if (this.realEstateForm.invalid) {
      Object.values(this.realEstateForm.controls).forEach((control) =>
        control.markAsDirty(),
      );
      return;
    }

    const closeValue: RunTransition = {
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
      params: {
        ...(this.data.extraParams ?? {}),
        ...this.getParams(),
      },
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  }
}
